module.exports = __webpack_public_path__ + "51056ebc9bdf10a85d862c9a341dae3e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/pt.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/pt.svg
// module chunks = 0